// extracted by mini-css-extract-plugin
export var divider = "_nq-0";
export var systemMessage = "_nq-1";
export var systemMessageWrapper = "_nq-2";